import {Outlet} from "react-router-dom"
import {FooterVariant} from "ui/blocks/FooterVariant/FooterVariant"
import {HeaderVariant} from "ui/blocks/HeaderVariant/HeaderVariant"
import {ScrollToTop} from "ui/base/ScrollToTop";

export const MainLayout = ({children, primary}) => {
    return (
        <ScrollToTop>
            <HeaderVariant primary={primary}/>
            {children ? children : <Outlet/>}
            <FooterVariant/>
        </ScrollToTop>
    )
}
